import { authenticatedFetch } from "./auth";
import type { AuthSession } from "./types";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string | undefined;

export type MessageMediaReview = {
  messageId: string;
  conversationId?: string;
  mediaReviewStatus: "queued" | "in_progress" | "completed" | "failed";
  mediaReviewJobName?: string;
  mediaReviewProvider?: "openai";
  mediaReviewModel?: string;
  mediaReviewScope?: "visual" | "document" | "video_audio";
  mediaReviewError?: string;
  mediaReviewSummary?: string;
  mediaReviewTranscript?: string;
};

export async function startRemoteMediaReview(
  conversationId: string,
  messageId: string,
  session: AuthSession,
) {
  if (!API_BASE_URL) throw new Error("API_NOT_CONFIGURED");
  const response = await authenticatedFetch(
    `${API_BASE_URL}/bridge/media-reviews/${encodeURIComponent(conversationId)}/${encodeURIComponent(messageId)}`,
    session,
    { method: "POST" },
  );
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const code = typeof body?.error === "string" ? body.error : `HTTP_${response.status}`;
    throw new Error(code);
  }
  return body as {
    item: MessageMediaReview;
    alreadyCompleted?: boolean;
    alreadyRunning?: boolean;
  };
}
